export const publicEmail = [
  "gmail.com",
  "outlook.com",
  "yahoo.com",
  "icloud",
  "mail.com",
  "hotmail.com",
  "rediffmail.com",
];
